module.exports = __webpack_public_path__ + "2981e8d4fe52754ba2a88af73a293b57.MP3";